module.exports = __webpack_public_path__ + "assets/img/3df5357b0da2c822ad2731423bbf90ad.png";